import { Component, OnInit } from "@angular/core";
import { DownloadService } from "../base/services/download.service";
import { FileLoaderService } from "../services/file-loader.service";

@Component({
  selector: "app-election",
  templateUrl: "./election.component.html",
  styleUrls: ["./election.component.scss"]
})
export class ElectionComponent implements OnInit {
  documents: Array<any> = [];

  constructor(
    private downloadService: DownloadService,
    private fileLoader: FileLoaderService
  ) {}

  ngOnInit(): void {
    this.loadDocs();
  }

  loadDocs() {
    this.fileLoader.getElectionDocs().subscribe(docs => {
      this.documents = docs;
    });
  }
  download(name: string, ext: string = null, path: string = null) {
    this.downloadService.download(path, name, ext);
  }
}
